import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LangEnum } from './enum';
import en from './config/en';
import zh_cn from './config/zh_cn';
import zh_hk from './config/zh_hk';

const resources = {
  [LangEnum.EN]: {
    translation: en,
  },
  [LangEnum.ZH_CN]: {
    translation: zh_cn,
  },
  [LangEnum.ZH_HK]: {
    translation: zh_hk,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: LangEnum.EN,
  fallbackLng: LangEnum.EN,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
